import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { AuthService } from "../../../../services/http/auth/auth.service";
import { environment } from "../../../../../environments/environment";
interface MobileAuthStatusResponse {
  status: 'pending' | 'success' | 'needs_otp' | 'failed';

  token?: {
    access_token: string;
    refresh_token: string;
    token_type: string;
    expires_in: number;
  };

  message?: string;
}
@Injectable({providedIn:'root'})
export class PaymentService {

  private authApi = environment.apiAuth;
  private apiBase = environment.apiBase;

  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {}

  start() {
    return this.http.get(`${this.apiBase}/start`);
  }

  sendCode(data: any) {
    return this.http.post(
      `${this.authApi}/login-code`,
      data
    );
  }
  sendPhoneCode(data: any) {
    return this.http.post(
      `${this.authApi}/mobile-auth`,
      data
    );
  }
  getMobileAuthStatus(requestId: number) {
    // hash игры — чтобы has_paid в ответе был про текущую игру (одноразовый билет привязан к игре)
    const hash = localStorage.getItem('hash');
    return this.http.get<MobileAuthStatusResponse>(
      `${this.authApi}/mobile-auth/status/${requestId}`,
      { params: hash ? { hash } : {} }
    ).pipe(
      tap((response: any) => {
        if (response.status === 'success')
        this.auth.setSession(response.token);
      })
    );;
  }
  
  verifyOtp(data: {request_id: number, code: string}) {
    return this.http.post(
      `${this.authApi}/mobile-auth/verify`,
      { ...data, hash: localStorage.getItem('hash') }
    ).pipe(
      tap((response: any) => {
        this.auth.setSession(response.token);
      })
    );
  }

  verifyMail(code: string) {
    return this.http.post(
      `${this.authApi}/code-verify`,
      { code, hash: localStorage.getItem('hash') }
    ).pipe(
      tap((response: any) => {
        this.auth.setSession(response.token.original);
      })
    );
  }

  createOrder(
    hash: string,
    token: string,
    product_id: number
  ): Observable<Response> {
    return this.http.post<Response>(
      `${this.apiBase}/orders/create/`,
      {
        hash,
        product_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Referer': window.location.href,
        },
      }
    );
  }

  confirmPayment(productId: number) {
    return this.http.get(`${this.apiBase}/orders/callback/${productId}`);
  }
}

interface Response {
  confirmation_url: string;
  order_id: number;
  confirmation_token: string;
  promocode_used?: boolean;
}
